import React from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

/*IMAGES*/
import { ReactComponent as CloseButton } from "../../Global/icons/closeIcon.svg";
import moment from "moment/moment.js";

/*STYLE*/
const StyledPrivacyPopup = styled(NanoFlex)`
  .container {
    position: fixed;
    z-index: 100;
    max-width: max-content;
    padding: 10px;
    transition: ${(props) => props.theme.transition};
    animation: rise 4s ease 1;
    height: fit-content;
    opacity: 1;
    bottom: 10px;
    background-color: #045091;
    border-radius: 5px;
    gap: 5px;

    a {
      color: white;
      text-decoration: underline;
    }

    p {
      color: white;
    }
  }

  .closeIcon {
    cursor: pointer;
    margin: 0 0 0 0;
    width: 23px;
    height: 23px;
    line-height: 25px;
    text-align: center;
    font-family: monospace;
    vertical-align: middle;
    font-weight: bold;
    font-size: 1.25rem;
    align-items: center;
    justify-content: center;
    transition: ${(props) => props.theme.transition};
    border-radius: 50%;

    path {
      fill: white;
    }

    &:hover {
      background-color: #ffffff50;
      border-radius: 50%;
      transition: ${(props) => props.theme.transition};
    }

    &:after {
      display: inline-block;
    }
  }

  @keyframes rise {
    0% {
      bottom: -20px;
      opacity: 0;
    }
    100% {
      bottom: 10px;
      opacity: 100%;
    }
  }
`;

/*EVENTS*/
export class PrivacyPopup extends BaseComponent {
  constructor(props) {
    super(props);

    let wasClosed = localStorage.getItem("privacyPopup");

    let alertDate = new Date(2023, 11, 1);

    let dateStart = moment(alertDate).add(-15, "days");
    let dateEnd = moment(alertDate).add(15, "days");

    const currentDate = moment();

    this.state = {
      showComponent: !wasClosed && currentDate >= dateStart && currentDate <= dateEnd,
      privacyUrl: currentDate >= dateStart ? "https://www.marktest.com/wap/a/q/lang~pt/id~106.aspx" : "https://www.marktest.com/wap/a/p/id~173.aspx",
    };

    if (!currentDate >= dateStart && currentDate <= dateEnd) localStorage.removeItem("privacyPopup");
  }

  componentDidMount() {
    super.componentDidMount();
  }

  closePopup = () => {
    localStorage.setItem("privacyPopup", "true");
    this.setState({ showComponent: false });
  };

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  /*HTML*/
  render() {
    if (!this.state.showComponent) return null;

    return (
      <StyledPrivacyPopup>
        <NanoFlex className="container">
          <NanoFlex>
            <Type.p dangerouslySetInnerHTML={{ __html: this.translation.popup.popupInfo.replace("[URL]", this.state.privacyUrl) }}></Type.p>
          </NanoFlex>
          <NanoFlex className="closeIcon" onClick={this.closePopup}>
            <CloseButton />
          </NanoFlex>
        </NanoFlex>
      </StyledPrivacyPopup>
    );
  }
}
